'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@headlessui/react';
import { useState } from 'react';
import { Link } from '../../../../actions/Link';
import { P3 } from '../../../typography/Paragraph';
import { type Goal, mentoringPodstawowyGoals, mentoringProjektowyGoals, mentoringSpersonalizowanyGoals } from '../_components/NavigationItems';
const getGoals = (categoryIndex: number): Goal[] => {
  switch (categoryIndex) {
    case 0:
      return mentoringPodstawowyGoals;
    case 1:
      return mentoringSpersonalizowanyGoals;
    case 2:
      return mentoringProjektowyGoals;
    default:
      return mentoringPodstawowyGoals;
  }
};
export function OfertaOptions(t0) {
  const $ = _c(28);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      goals: mentoringPodstawowyGoals,
      categoryIndex: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = categoryIndex => {
      setState({
        goals: getGoals(categoryIndex),
        categoryIndex
      });
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleCategoryChange = t2;
  const t3 = state.categoryIndex === 0;
  const t4 = `rounded-tl-3xl p-4 font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${state.categoryIndex === 0 ? "bg-white text-algosecondary" : ""}`;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => handleCategoryChange(0);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3 || $[4] !== t4) {
    t6 = <Button type="button" aria-pressed={t3} className={t4} onClick={t5}>Mentoring podstawowy</Button>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = state.categoryIndex === 1;
  const t8 = `border-x-2 p-4 font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${state.categoryIndex === 1 ? "bg-white text-algosecondary" : ""}`;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => handleCategoryChange(1);
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t7 || $[8] !== t8) {
    t10 = <Button type="button" aria-pressed={t7} className={t8} onClick={t9}>Mentoring rozszerzony</Button>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = state.categoryIndex === 2;
  const t12 = `rounded-tr-3xl p-4 font-semibold text-sm leading-6 hover:bg-slate-100 hover:text-algosecondary hover:underline ${state.categoryIndex === 2 ? "bg-white text-algosecondary" : ""}`;
  let t13;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => handleCategoryChange(2);
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== t11 || $[12] !== t12) {
    t14 = <Button type="button" aria-pressed={t11} className={t12} onClick={t13}>Mentoring projektowy</Button>;
    $[11] = t11;
    $[12] = t12;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t10 || $[15] !== t14 || $[16] !== t6) {
    t15 = <div className="grid grid-cols-3 border-b-2 bg-slate-50">{t6}{t10}{t14}</div>;
    $[14] = t10;
    $[15] = t14;
    $[16] = t6;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== onClose || $[19] !== state.goals) {
    let t17;
    if ($[21] !== onClose) {
      t17 = item => <div key={item.href} className="group relative flex cursor-pointer gap-x-6 rounded-lg p-4 hover:bg-slate-50"><div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-slate-50 group-hover:bg-white"><span className="h-6 w-6 text-slate-600 group-hover:fill-algosecondary group-hover:text-algosecondary" aria-hidden="true">{item.icon}</span></div><div><Link href={item.href} onClick={onClose} className="font-semibold text-slate-900">{item.name}<span className="absolute inset-0" /></Link><P3 className="mt-1">{item.description}</P3></div></div>;
      $[21] = onClose;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    t16 = state.goals.map(t17);
    $[18] = onClose;
    $[19] = state.goals;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[23] !== t16) {
    t17 = <div className="grid grid-cols-1 gap-x-6 gap-y-1 p-4 lg:grid-cols-2">{t16}</div>;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t15 || $[26] !== t17) {
    t18 = <>{t15}{t17}</>;
    $[25] = t15;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
}